/*eslint-disable */
import {
  mapGetters
} from 'vuex'; 
const $ = window.jQuery = require('jquery'); 
import axios from 'axios'; 
import countries from '../../../services/country.json'
export default {
  name: 'user-connection-request-list',
  components: {},
  props: [],
  data () {
    return {
      connReqList:{},
      userLoading: false,
      submitted:false,
      countryList:[],
    }
  },
  computed: {
  ...mapGetters([
    'userChatRequestListGetters'
  ]),
  getconnReqListDetailsFun(){
    return this.connReqList = this.$store.getters.userChatRequestListGetters.data
  },
  },
  mounted () {
    Object.keys(countries).map((key, index) => {
      this.countryList.push({
        name: countries[key].toLowerCase(),
        value: key.toLowerCase()
      })
    });
    this.countryList.sort((a, b) => (a.name > b.name) ? 1 : -1)
    this.getconnReqListDetailsFun
  },
  methods: {
    getCountryFlag: function(countryCode, type) {
      if (countryCode == null) {
        countryCode = ''
      }
      let countryName = countryCode.toLowerCase()
      let country = this.countryList.filter(item => (item.value) == (countryName) || (item.name) == (countryName));
      if (country && country.length > 0) {
        country = country[0]
        if (type == 'flag') {
          country = `https://www.countryflags.io/${country.value}/shiny/64.png`
        } else {
          country = country.name
        }
      } else {
        country = ''
      }
      return country;
    }
  },
  watch:{
    getconnReqListDetailsFun(){
      return this.connReqList = this.$store.getters.userChatRequestListGetters.data
    },
  }
}